"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.BubbleTypeList=void 0;var t;(function(e){e.Category="category",e.CategoryGroup="category_group",e.Shipment="shipment",e.Store="store"})(t||(exports.BubbleTypeList=t={}));
//# sourceMappingURL=BubbleTypeList.js.map
